import axios from "axios";
import { getToken, getTokenHeader } from "../../../Token";
import { registerNotificationTokenUrl } from "../urls";

export const registerNotificationToken = async (userToken, data) => {
  console.log("userToken", userToken);
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${registerNotificationTokenUrl(userToken)}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
